<template>
    <div>
        <el-dialog :visible.sync="editDialogVisible" :close-on-click-modal="false" width="50%" :before-close="resetForm" title="编辑商家">
            <el-form :model="editForm" ref="editForm" :rules="rules" label-width="80px" label-position="center">
                <el-row type="flex" class="row-bg" justify="space-around">
                    <el-col :span="12"
                        ><div class="grid-content bg-purple-light">
                            <el-form-item label="商家类型" prop="merchantType">
                                <el-select v-model="editForm.merchantType" placeholder="请选择商家类型">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item></div
                    ></el-col>
                    <el-col :span="12"
                        ><div class="grid-content bg-purple-light">
                            <el-form-item label="门店名称" prop="merchantName">
                                <el-input v-model.trim="editForm.merchantName" placeholder="请输入门店名称"></el-input>
                            </el-form-item></div
                    ></el-col>
                </el-row>
                <!-- <el-form-item label="显示分类" prop="key">
                <el-select v-model="addForm.showType" multiple placeholder="请选择" @change="selectChange" :multiple-limit="5">
                    <el-option v-for="item in showType" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </el-form-item> -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="工作时间" style="margin-bottom:0;">
                            <el-col :span="12">
                                <el-form-item prop="startWorkTime">
                                    <el-time-picker
                                        v-model="editForm.startWorkTime"
                                        class="date-box"
                                        format="HH:mm"
                                        value-format="HH:mm"
                                        placeholder="请选择开始时间"
                                        :picker-options="{
                                            selectableRange: `00:00:00 -${editForm.endWorkTime ? editForm.endWorkTime + ':00' : '23:59:00'}`
                                        }"
                                    >
                                    </el-time-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="endWorkTime">
                                    <el-time-picker
                                        v-model="editForm.endWorkTime"
                                        format="HH:mm"
                                        value-format="HH:mm"
                                        placeholder="请选择结束时间"
                                        :picker-options="{
                                            selectableRange: `${
                                                editForm.startWorkTime ? editForm.startWorkTime + ':00' : '00:00:00'
                                            }-23:59:00`
                                        }"
                                    >
                                    </el-time-picker>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="门店地址">
                            <el-col :span="8">
                                <el-form-item prop="province">
                                    <el-select
                                        v-model="editForm.province"
                                        filterable
                                        size="small"
                                        @change="selectProvinceFun($event)"
                                        placeholder="请选择省份"
                                    >
                                        <el-option value="" label="请选择省份"></el-option>
                                        <el-option
                                            :value="item.name"
                                            :label="item.name"
                                            v-for="(item, index) in city"
                                            :key="index"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item prop="city">
                                    <el-select
                                        v-model="editForm.city"
                                        filterable
                                        size="small"
                                        @change="selectCityFun($event)"
                                        placeholder="请选择城市"
                                    >
                                        <el-option value="" label="请选择城市"></el-option>
                                        <el-option
                                            :value="item.name"
                                            :label="item.name"
                                            v-for="(item, index) in cityList"
                                            :key="index"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item prop="area">
                                    <el-select
                                        v-model="editForm.area"
                                        filterable
                                        size="small"
                                        @change="selectAreaFun($event)"
                                        placeholder="请选择区县"
                                    >
                                        <el-option value="" label="请选择区县"></el-option>
                                        <el-option :value="item" :label="item" v-for="(item, index) in areaList" :key="index"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="用户名" prop="merchantLoginName">
                            <el-input v-model.trim="editForm.merchantLoginName" placeholder="请输入用户名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="详细地址" prop="merchantAddress">
                            <el-input v-model.trim="editForm.merchantAddress" placeholder="请输入门店详细地址"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="登录密码" prop="merchantPassword">
                            <el-input
                                v-model.trim="editForm.merchantPassword"
                                placeholder="请输入登录密码"
                                :type="pwdType1"
                                oninput="value=value.replace(/[\W]/g,'')"
                                readonly
                            >
                                <i slot="suffix" class="el-input__icon el-icon-view" :class="{ pwd: isPwd1 }" @click="handleToPwd1"></i>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商家卖点" prop="merchantFeatures">
                            <el-input v-model.trim="editForm.merchantFeatures" placeholder="请输入商家卖点"> </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="联系电话" prop="merchantTelephone">
                            <el-input v-model.trim="editForm.merchantTelephone" placeholder="请输入联系电话"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12"> </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="资质照片" prop="merchantQuantityImg">
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-success="quaHandleAvatarSuccess"
                                :before-upload="BeforeAvatarUpload"
                            >
                                <img v-if="quaImageUrl" :src="quaImageUrl" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                <div class="el-upload__tip" >温馨提示：建议上传一张宽高比为 7:5 的图片,建议：350px*250px</div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="logo图片" prop="merchantImg">
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload"
                                :on-change="uploadHandleChange"
                                :http-request="handleHttpRequest"
                                :auto-upload="false"
                            >
                                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="门店服务" prop="merchantServer">
                    <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleCloseTag(tag)">
                        {{ tag }}
                    </el-tag>
                    <el-input
                        class="input-new-tag"
                        v-if="inputVisible"
                        v-model="editForm.merchantServer"
                        ref="saveTagInput"
                        size="small"
                        @keyup.enter.native="handleInputConfirm"
                        @blur="handleInputConfirm"
                    >
                    </el-input>
                    <el-button v-else class="button-new-tag" size="small" @click="showInput">+标签</el-button>
                </el-form-item>
                <el-form-item label="门店简介" prop="merchantIntroduction">
                    <quill-editor
                        v-model="editForm.merchantIntroduction"
                        ref="myQuillEditor"
                        class="editor ql-editor editReset"
                        id="editor"
                        @change="onEditorChange($event)"
                        @keydown.native="onEditorKeyDown($event)"
                        @blur="onEditorblur()"
                    ></quill-editor>
                </el-form-item>

                <div class="dialog-footer">
                    <el-button type="info" @click="resetForm">取 消</el-button>
                    <el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="图片剪裁" :visible.sync="logoDialogVisible" append-to-body :close-on-click-modal="false">
            <div class="cropper-content">
                <div class="cropper" style="text-align: center;">
                    <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :info="true"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :fixed="option.fixed"
                        :fixedNumber="option.fixedNumber"
                        :centerBox="option.centerBox"
                        :infoTrue="option.infoTrue"
                        :fixedBox="option.fixedBox"
                    ></vueCropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeScale(1)">+</el-button>
                <el-button @click="changeScale(-1)">-</el-button>
                <el-button @click="rotateLeft">↺</el-button>
                <el-button @click="rotateRight">↻</el-button>
                <el-button @click="logoDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="finish">上传</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import city from '@/assets/json/map.json';
import { quillEditor } from 'vue-quill-editor';
const titleConfig = [
    { Choice: '.ql-bold', title: '加粗' },
    { Choice: '.ql-italic', title: '斜体' },
    { Choice: '.ql-underline', title: '下划线' },
    { Choice: '.ql-header', title: '段落格式' },
    { Choice: '.ql-strike', title: '删除线' },
    { Choice: '.ql-blockquote', title: '块引用' },
    { Choice: '.ql-code', title: '插入代码' },
    { Choice: '.ql-code-block', title: '插入代码段' },
    { Choice: '.ql-font', title: '字体' },
    { Choice: '.ql-size', title: '字体大小' },
    { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
    { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
    { Choice: '.ql-direction', title: '文本方向' },
    { Choice: '.ql-header[value="1"]', title: 'h1标题' },
    { Choice: '.ql-header[value="2"]', title: 'h2标题' },
    { Choice: '.ql-align', title: '对齐方式' },
    { Choice: '.ql-color', title: '字体颜色' },
    { Choice: '.ql-background', title: '背景颜色' },
    { Choice: '.ql-image', title: '图像' },
    { Choice: '.ql-video', title: '视频' },
    { Choice: '.ql-link', title: '添加链接' },
    { Choice: '.ql-formula', title: '插入公式' },
    { Choice: '.ql-clean', title: '清除字体格式' },
    { Choice: '.ql-script[value="sub"]', title: '下标' },
    { Choice: '.ql-script[value="super"]', title: '上标' },
    { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
    { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
    { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
    { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
    { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
    { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
    { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
    { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
    { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
    { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
    { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
    { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
    { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
    { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
    { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
    {
        Choice: '.ql-align .ql-picker-item[data-value="center"]',
        title: '居中对齐'
    },
    {
        Choice: '.ql-align .ql-picker-item[data-value="right"]',
        title: '居右对齐'
    },
    {
        Choice: '.ql-align .ql-picker-item[data-value="justify"]',
        title: '两端对齐'
    }
];
export default {
    props: ['editData'],
    components: {
        quillEditor
    },
    data() {
        var checkLogins = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入用户名'));
            } else {
                var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
                if (value) {
                    if (!reg.test(value)) {
                        callback(new Error('用户名6-16位仅支持字母、数字的组合'));
                    } else {
                        let data = {};
                        data.merchantLoginName = this.addForm.merchantLoginName;
                        data.id = this.id;
                        this.$axios.post('merchant/judgeMerchantLoginName', data).then(res => {
                            if (res.data.code != 0) {
                                callback(new Error(res.data.data));
                            } else {
                                callback();
                            }
                        });
                    }
                }
            }
        };
        var checkMerchantName = (rule, value, callback) => {
            let that = this;
            if (!value) {
                return callback(new Error('请输入门店名称'));
            }
            let data = {};
            data.merchantName = that.editForm.merchantName;
            data.id = this.id;
            that.$axios.post('merchant/judgeMerchantName', data).then(res => {
                if (res.data.code != 0) {
                    callback(new Error(res.data.data));
                } else {
                    callback();
                }
            });
        };
         var checkMerchantAddress = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入门店详细地址'));
            }else{
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入密码'));
            } else if (value.length < 5 || value.length > 16) {
                callback(new Error('密码长度为6-16位'));
            } else {
                var reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
                if (!reg.test(value)) {
                    callback(new Error('密码仅支持字母、数字的组合'));
                } else {
                    callback();
                }
            }
        };
        var merchantServers = (rule, value, callback) => {
            console.log('服务', value[value.length - 1]);
            console.log('服务1', value);
            console.log(this.dynamicTags);
            if (this.flag == 1) {
                var reg = /^[\u4e00-\u9fa5]+$/;
                if (this.dynamicTags.length == 0) {
                    callback(new Error('请输入门店服务'));
                } else if (value[value.length - 1].length > 5 || this.dynamicTags.length > 6) {
                    callback(new Error('门店服务每个标签最大输入长度为5个字符且最多为6个标签'));
                    this.dynamicTags.splice(this.dynamicTags.indexOf(value[value.length - 1]), 1);
                } else if (!reg.test(value[value.length - 1])) {
                    callback(new Error('请输入汉字'));
                    this.dynamicTags.splice(this.dynamicTags.indexOf(value[value.length - 1]), 1);
                } else {
                    function fn(Arr, num) {
                        let w = 0,
                            n;
                        for (let i = 0; i < Arr.length; i++) {
                            if (Arr.indexOf(num, i) != Arr.indexOf(num, i - 1)) {
                                w++;
                            }
                        }
                        return w;
                    }
                    console.log(fn(this.dynamicTags, value));
                    var count = fn(this.dynamicTags, value);
                    if (count >= 2) {
                        callback(new Error('请不要输入重复值'));
                        this.dynamicTags.splice(this.dynamicTags.indexOf(value[value.length - 1]), 1);
                    } else {
                        callback();
                    }
                }
            } else if (this.flag == 0) {
                var reg = /^[\u4e00-\u9fa5]+$/;
                if (this.dynamicTags.length == 0) {
                    callback(new Error('请输入门店服务'));
                } else if (value.length > 5 || this.dynamicTags.length > 6) {
                    callback(new Error('门店服务每个标签最大输入长度为5个字符且最多为6个标签'));
                    this.dynamicTags.splice(this.dynamicTags.indexOf(value), 1);
                    this.editForm.merchantServer = this.dynamicTags[this.dynamicTags.length - 1];
                    console.log(this.dynamicTags, 44);
                } else if (!reg.test(value)) {
                    callback(new Error('请输入汉字'));
                    this.dynamicTags.splice(this.dynamicTags.indexOf(value), 1);
                    this.editForm.merchantServer = this.dynamicTags[this.dynamicTags.length - 1];
                } else {
                    function fn(Arr, num) {
                        let w = 0,
                            n;
                        for (let i = 0; i < Arr.length; i++) {
                            if (Arr.indexOf(num, i) != Arr.indexOf(num, i - 1)) {
                                w++;
                            }
                        }
                        return w;
                    }
                    console.log(fn(this.dynamicTags, value));
                    var count = fn(this.dynamicTags, value);
                    if (count >= 2) {
                        callback(new Error('请不要输入重复值'));
                        this.dynamicTags.splice(this.dynamicTags.indexOf(value), 1);
                        this.editForm.merchantServer = this.dynamicTags[this.dynamicTags.length - 1];
                    } else {
                        callback();
                    }
                }
            }
        };
        return {
            // 新增表单数据
            imageUrl: '',
            quaImageUrl: '',
            editDialogVisible: false,
            options: [
                {
                    value: '服务',
                    label: '服务'
                },
                {
                    value: '吃住',
                    label: '吃住'
                },
                // {
                //     value: '洗车',
                //     label: '洗车'
                // },
                {
                    value: '其他',
                    label: '其他'
                }
            ],
            status: [
                {
                    value: '0',
                    label: '未营业'
                },
                {
                    value: '1',
                    label: '正在营业'
                }
            ],
            editForm: {
                merchantType: '', //商家类型
                merchantName: '', //商家名称
                startWorkTime: '', //工作开始时间
                endWorkTime: '', //工作结束时间
                merchantAddress: '', //商家详细地址
                province: '', //省
                city: '', //市
                area: '', //区
                id: '',
                merchantFeatures: '',
                merchantStatus: '', //营业状态
                merchantTelephone: '', //联系电话
                merchantIntroduction: '', //商家简介
                merchantImg: '', //商家图片
                merchantServer: '', //门店服务
                merchantQuantityImg: '', //商家资质图片
                merchantLoginName: '',
                merchantPassword: ''
            },
            uploadUrl: 'upload/fileupload', //图片上传地址
            flag: 1,
            id: '',
            dynamicTags: [],
            inputVisible: false,
            inputValue: '',
            // 验证规则
            rules: {
                merchantType: [{ required: true, message: '请选择商家类型', trigger: 'change' }],
                merchantName: [
                    { validator: checkMerchantName, trigger: 'blur' },
                    { required: true, min: 1, max: 12, message: '门店名称长度在 1 到 12 个字符', trigger: 'blur' }
                ],
                merchantFeatures: [
                    { required: true, message: '请输入商家卖点', trigger: 'blur' },
                    { min: 2, max: 10, message: '商家卖点长度在 2 到 10个字符', trigger: 'blur' }
                ],
                startWorkTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
                endWorkTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
                merchantAddress: [{ required: true, validator: checkMerchantAddress, trigger: 'blur' }],
                province: [{ required: true, message: '请选择省', trigger: 'change' }],
                city: [{ required: true, message: '请选择市', trigger: 'change' }],
                area: [{ required: true, message: '请选择区县', trigger: 'change' }],

                merchantStatus: [{ required: true, message: '请选择营业状态', trigger: 'change' }],
                merchantTelephone: [
                    {
                        required: true,
                        message: '请输入联系电话',
                        trigger: 'blur'
                    },
                    {
                        pattern: /^(((\d{3,4}-)?[0-9]{7,8})|(1(3|4|5|6|7|8|9)\d{9}))$/,
                        message: '联系电话格式不正确！',
                        trigger: 'blur'
                    }
                ],
                merchantIntroduction: [{ required: true, message: '请输入门店简介', trigger: 'blur' }],
                merchantImg: [
                    {
                        required: true,
                        message: '请上传商家图片',
                        trigger: 'change'
                    }
                ],
                merchantQuantityImg: [
                    {
                        required: true,
                        message: '请上传资质图片',
                        trigger: 'change'
                    }
                ],
                merchantServer: [
                    { required: true, message: '请输入门店服务', trigger: 'blur' },
                    { validator: merchantServers, trigger: 'blur' }
                ]
            },
            // 整个省市县数据
            city: city,
            // 被选中的市数据
            cityList: [],
            // 被选中的县数据
            areaList: [],
            selectProvince: {},
            selectCity: {},
            selectArea: {},
            pwdType1: 'password',
            isPwd1: false,
            option: {
                img: '', // 裁剪图片的地址
                info: false, // 裁剪框的大小信息
                outputSize: 0.8, // 裁剪生成图片的质量
                outputType: 'jpeg', // 裁剪生成图片的格式
                canScale: true, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                autoCropWidth: 600, // 默认生成截图框宽度
                autoCropHeight: 700, // 默认生成截图框高度
                fixedBox: false, // 固定截图框大小 不允许改变
                fixed: false, // 是否开启截图框宽高固定比例
                // fixedNumber: [5.8, 6], // 截图框的宽高比例
                full: true, // 是否输出原图比例的截图
                canMoveBox: true, // 截图框能否拖动
                canMove: false,
                original: false, // 上传图片按照原始比例渲染
                centerBox: true, // 截图框是否被限制在图片里面
                infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            },
            logoDialogVisible: false, //图片裁剪的弹框dialog
            logoFilename: '', //文件名
            merchantLat:'',
            merchantLng:'',
            // quaDialogVisible: false, //图片裁剪的弹框dialog
            // quaFilename: '' //文件名
        };
    },
    created() {
        console.log(this.id);
        // this.getMerchantInfo();
    },
    mounted() {
        // this.getMerchantInfo();
    },
    methods: {
        addQuillTitle() {
            document.getElementsByClassName('ql-editor')[0].dataset.placeholder = '';
            for (let item of titleConfig) {
                let tip = document.querySelector('.quill-editor ' + item.Choice);
                if (!tip) continue;
                tip.setAttribute('title', item.title);
            }
        },
        async getMerchantInfo(id) {
            this.id = id;
            let that = this;
            const res = await that.$axios.post('merchant/getData', {
                id: id
            });
            console.log(res);
            console.log(that.dynamicTags, 99);
            if (res.data.code == 0) {
                that.editForm = res.data.data;
                var arr = [];
                arr.push(res.data.data.startWorkTime);
                arr.push(res.data.data.endWorkTime);
                arr = arr.join(',');
                console.log(arr);
                that.editForm.timeRange = arr;
                console.log(that.editForm.timeRange);
                that.dynamicTags = res.data.data.merchantServer.split('、');
                console.log(that.dynamicTags, 99);
                that.editForm.merchantServer = that.dynamicTags;
                console.log(that.editForm.merchantServer, 95);
                that.imageUrl = res.data.data.merchantImgUrl;
                that.quaImageUrl = res.data.data.merchantQuantityImgUrl;
                that.$nextTick(() => {
                    document.getElementById('editor').children[1].children[0].setAttribute('data-placeholder', '请输入门店简介');
                    that.addQuillTitle();
                    that.city.forEach(function(item) {
                        console.log(item);
                        if (item.name == that.editForm.province) {
                            that.cityList = item.children;
                        }
                        // console.log(that.cityList);
                    });
                    that.cityList.forEach(function(items) {
                        console.log(items);
                        if (items.name == that.editForm.city) {
                            that.areaList = items.children;
                        }
                        // console.log(that.cityList);
                    });
                });
                that.editDialogVisible = true;
            }
        },
        handleCloseTag(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },

        showInput() {
            let that = this;
            that.inputVisible = true;
            that.editForm.merchantServer = '';
            that.$nextTick(_ => {
                that.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.editForm.merchantServer;
            console.log(inputValue);
            if (inputValue.length > 5) {
                console.log(6666);
            }
            if (inputValue) {
                this.dynamicTags.push(inputValue);
                console.log(this.dynamicTags);
            }
            this.inputVisible = false;
            this.flag = 0;
            // this.addForm.merchantServer = '';
        },
        handleAvatarSuccess() {},
        beforeAvatarUpload(file) {},
        quaHandleAvatarSuccess() {},
       BeforeAvatarUpload(file) {
            let that = this;
            console.log(file);
            if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                that.$message.error('请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片');
                return false;
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                that.$message.error('图片大小必须小于2M');
                return false;
            }
            if (file.type && isLt2M) {
                let fd = new FormData(); //通过form数据格式来传
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };
                fd.append('file', file); //传文件
                that.$axios.post(that.uploadUrl, fd, config).then(function(res) {
                    console.log(res.data);
                    if (res.data.code == 0) {
                        that.editForm.merchantQuantityImg = res.data.data.id;
                        that.quaImageUrl = res.data.data.url;
                    } else {
                        that.$message.error(res.data);
                    }
                });
            }
        },
        uploadHandleChange(file) {
            // alert(5)
            this.logoFilename = file.name;
            const isLt2M = file.size / 1024 / 1024 < 2;
            const isIMG = ['.jpeg', '.jpg', '.png', '.bmp', '.gif', '.JPEG', '.JPG', '.GIF', '.PNG', '.BMP'].some(r =>
                file.name.endsWith(r)
            );
            if (!isIMG) {
                this.$message.error('上传图片只能是 jpg、jpeg、gif、 png、bmp 格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
                return false;
            }
            this.$nextTick(() => {
                this.option.img = URL.createObjectURL(file.raw);
                this.logoDialogVisible = true;
            });
        },
        changeScale(val) {
            this.$refs.cropper.changeScale(val);
        },
        // 旋转图片
        rotateLeft() {
            this.$refs.cropper.rotateLeft();
        },
        rotateRight() {
            this.$refs.cropper.rotateRight();
        },
        //确定裁剪
        finish() {
            this.$refs.cropper.getCropData(res => {
                let file = this.dataURLtoFile(res, this.logoFilename);
                this.handleHttpRequest(file);
                this.logoDialogVisible = false;
            });
        },
        // base64转file
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        //上传事件
        async handleHttpRequest(file) {
            let that = this;
            console.log(file);
            let formData = new FormData();
            formData.append('file', file);
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            const res = await this.$axios.post(that.uploadUrl, formData, config);
            console.log(res);
            if (res.data.code == 0) {
                that.editForm.merchantImg = res.data.data.id;
                that.imageUrl = res.data.data.url;
            } else {
                this.$message.error(res.data);
            }
        },
        //点击关闭按钮时关闭裁剪弹出框
        handleClose() {
            this.logoDialogVisible = false;
        },
        submitForm() {
            let that = this;
            console.log(that.editForm);
            console.log(that.dynamicTags);
            that.$refs.editForm.validate(valid => {
                if (valid) {
                    that.$axios
                        .post('merchant/update', {
                            merchantType: that.editForm.merchantType, //商家类型
                            merchantName: that.editForm.merchantName, //商家类型
                            startWorkTime: that.editForm.startWorkTime, //商家类型
                            endWorkTime: that.editForm.endWorkTime, //商家类型
                            merchantAddress: that.editForm.merchantAddress, //商家类型
                            province: that.editForm.province, //商家类型
                            city: that.editForm.city, //商家类型
                            area: that.editForm.area, //商家类型
                            merchantFeatures: that.editForm.merchantFeatures, //商家类型
                            merchantStatus: that.editForm.merchantStatus, //商家类型
                            merchantTelephone: that.editForm.merchantTelephone, //商家类型
                            merchantIntroduction: that.editForm.merchantIntroduction, //商家类型
                            merchantImg: that.editForm.merchantImg, //商家类型
                            merchantServer: that.dynamicTags.length == 0 ? '' : that.dynamicTags.join('、'), //商家类型
                            merchantQuantityImg: that.editForm.merchantQuantityImg, //商家类型
                            merchantLoginName: that.editForm.merchantLoginName, //商家类型
                            merchantPassword: that.editForm.merchantPassword, //商家类型
                            merchantLng:that.merchantLng,
                            merchantLat:that.merchantLat,
                            id: that.id
                        })
                        .then(res => {
                            console.log(res);
                            if (res.data.code == 0) {
                                that.$message.success('修改成功');
                                that.editDialogVisible = false;
                                that.$parent.getSysInfoList();
                                that.isPwd1 = false;
                                that.pwdType1 = 'password';
                                that.$axios
                                    .post('merchant/setLngAndLat', {
                                        merchantId: that.id
                                    })
                                    .then(res => {
                                        if (res.data.code == 0) {
                                            console.log('成功');
                                        }
                                    });
                            } else {
                                that.$message.error(res.data.data);
                            }
                            console.log(res);
                        });
                } else {
                    return false;
                }
            });
        },

        onEditorblur() {},
        // 富文本编辑器的change事件
        onEditorChange({ editor, html, text }) {},
        onEditorKeyDown(event) {},
        resetForm(formName) {
            let that = this;
            that.$confirm('确认放弃对当前页面信息的修改吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    that.$refs.editForm.resetFields();
                    that.merchantQuantityImg = '';
                    that.merchantImg = '';
                    that.imageUrl = '';
                    that.isPwd1 = false;
                    that.pwdType1 = 'password';
                    that.editDialogVisible = false;
                })
                .catch(() => {});
        },
        handleToClose() {
            console.log(1);
            let that = this;
            that.$confirm('确认放弃对当前页面信息的修改吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    that.$refs.editForm.resetFields();
                    that.merchantQuantityImg = '';
                    that.merchantImg = '';
                    that.imageUrl = '';
                    that.editDialogVisible = false;
                })
                .catch(() => {});
            // 重置表单
        },
        resetFormData(formName) {
            this.$refs[formName].resetFields();
        },
        selectProvinceFun(event) {
            let that = this;
            // console.log(event);
            if (event) {
                this.city.forEach(function(item) {
                    // console.log(item);
                    if (item.name == event) {
                        that.cityList = item.children;
                    }
                    // console.log(that.cityList);
                });
            } else {
                this.cityList = [];
            }
            this.areaList = [];
        },
        selectCityFun(event) {
            let that = this;
            // console.log(event);
            if (event) {
                this.cityList.forEach(function(item) {
                    // console.log(item);
                    if (item.name == event) {
                        that.areaList = item.children;
                    }
                    // console.log(that.areaList);
                });
            } else {
                this.areaList = [];
            }
        },
        selectAreaFun(event) {
            console.log(event);
        },
        // checkMerchantName() {
        //     this.$axios
        //         .post('merchant/judgeMerchantName', {
        //             merchantName: this.editForm.merchantName,
        //             id: this.editData
        //         })
        //         .then(res => {
        //             if (res.data.code !== 0) {
        //                 this.$message.error(res.data.data);
        //                 return false;
        //             }
        //         });
        // },
        // checkMerchantAddress() {
        //     this.$axios
        //         .post('merchant/judgeMerchantAddressIsRight', {
        //             merchantAddress: this.editForm.merchantAddress,
        //             province: this.editForm.province,
        //             city: this.editForm.city,
        //             area: this.editForm.area
        //         })
        //         .then(res => {
        //             if (res.data.code !== 0) {
        //                 this.$message.error(res.data.data);
        //                 return false;
        //             }
        //         });
        // },
        // checkMerchantLoginName() {
        //     this.$axios
        //         .post('merchant/judgeMerchantLoginName', {
        //             merchantLoginName: this.editForm.merchantLoginName
        //         })
        //         .then(res => {
        //             if (res.data.code !== 0) {
        //                 this.$message.error(res.data.data);
        //                 return false;
        //             }
        //         });
        // },
        handleToClose() {
            this.editDialogVisible = false;
            // 重置表单
            this.$refs.editForm.resetFields();
        },
        handleToPwd1() {
            this.isPwd1 = !this.isPwd1;
            if (this.isPwd1) {
                this.pwdType1 = 'text';
            } else {
                this.pwdType1 = 'password';
            }
        },
        //资质裁剪
        quaBeforeAvatarUpload(file) {
            // let that = this;
            // console.log(file);
            // if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
            //     that.$message.error('请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片');
            //     return false;
            // }
            // const isLt2M = file.size / 1024 / 1024 < 2;
            // if (!isLt2M) {
            //     that.$message.error('图片大小必须小于2M');
            //     return false;
            // }
            // if (file.type && isLt2M) {
            //     let fd = new FormData(); //通过form数据格式来传
            //     let config = {
            //         headers: {
            //             'Content-Type': 'multipart/form-data'
            //         }
            //     };
            //     fd.append('file', file); //传文件
            //     that.$axios.post(that.uploadUrl, fd, config).then(function(res) {
            //         console.log(res.data);
            //         if (res.data.code == 0) {
            //             that.editForm.merchantQuantityImg = res.data.data.id;
            //             that.quaImageUrl = res.data.data.url;
            //         } else {
            //             this.$message.error(res.data);
            //         }
            //     });
            // }
        },
        quauploadHandleChange(file) {
            // alert(5)
            this.quaFilename = file.name;
            const isLt2M = file.size / 1024 / 1024 < 2;
            const isIMG = ['.jpeg', '.jpg', '.png', '.bmp', '.gif', '.JPEG', '.JPG', '.GIF', '.PNG', '.BMP'].some(r =>
                file.name.endsWith(r)
            );
            if (!isIMG) {
                this.$message.error('上传图片只能是 jpg、jpeg、gif、 png、bmp 格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
                return false;
            }
            this.$nextTick(() => {
                this.option.img = URL.createObjectURL(file.raw);
                this.quaDialogVisible = true;
            });
        },
        changeScale(val) {
            this.$refs.cropper.changeScale(val);
        },
        // 旋转图片
        rotateLeft() {
            this.$refs.cropper.rotateLeft();
        },
        rotateRight() {
            this.$refs.cropper.rotateRight();
        },
        //确定裁剪
        finishs() {
            this.$refs.cropper.getCropData(res => {
                let file = this.dataURLtoFile(res, this.quaFilename);
                this.quahandleHttpRequest(file);
                this.quaDialogVisible = false;
            });
        },
        // base64转file
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        //上传事件
        async quahandleHttpRequest(file) {
            let that = this;
            console.log(file);
            let formData = new FormData();
            formData.append('file', file);
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            const res = await this.$axios.post(that.uploadUrl, formData, config);
            console.log(res);
            if (res.data.code == 0) {
                that.editForm.merchantQuantityImg = res.data.data.id;
                that.quaImageUrl = res.data.data.url;
            } else {
                this.$message.error(res.data);
            }
        },
        //点击关闭按钮时关闭裁剪弹出框
        handleCloses() {
            this.quaDialogVisible = false;
        }
        //
    }
};
</script>

<style lang="less" scoped>
.dialog-footer {
    text-align: right;
}
.el-select {
    width: 100%;
}
/deep/.el-input-number .el-input__inner {
    text-align: left;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    border: 1px dashed #d9d9d9;
}
.avatar {
    width: 148px;
    height: 148px;
    display: block;
}
.pwd {
    color: #409eff;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
    display: inline-block;
}
.el-tag + .el-tag {
    margin-left: 10px;
}
.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin-bottom: 15px;
}
.cropper-content .cropper {
    width: auto;
    height: 300px;
}
</style>
